module.exports = __webpack_public_path__ + "img/2.6c5b6d1d.png";